import { cn } from "../../utils/cn";
import {
  ActionMenuItem,
  Column,
  FleetrifyCustomTable,
} from "../CustomTable/customTable";

interface TableData {
  id: string;
  branchName: string;
  location: string;
  status: string;
  date: string;
}

export interface AnimatedTableProps {
  data: TableData[];
  columns: Column[];
  checkbox?: boolean;
  initialPage?: number;
  initialPageSize?: number;
  className?: string;
  view?: boolean;
}

const CompanyBranchesTable = ({
  renderLeftContent,
  actionMenu,
}: {
  renderLeftContent: React.ReactNode;
  actionMenu: (row: any) => ActionMenuItem[];
}) => {
  const tableData: TableData[] = [
    {
      id: "b9e1c7f0-2a3b-4c5d-8e9f-0a1b2c3d4e5f",
      branchName: "Dom Enterprise",
      location: "Lagos",
      status: "Active",
      date: "March 15, 2025",
    },
    {
      id: "a8d2b6e1-3c4d-5e6f-9a0b-1c2d3e4f5a6b",
      branchName: "Peniel Travels",
      location: "Kumasi",
      status: "Inactive",
      date: "August 12, 2025",
    },
    {
      id: "c7f3d5a2-4b5c-6d7e-0f1a-2b3c4d5e6f7a",
      branchName: "Charly & Sons",
      location: "Abuja",
      status: "Active",
      date: "March 15, 2025",
    },
  ];

  const columns: Column[] = [
    { label: "Branch Name", key: "branchName", sortable: true },
    { label: "Location", key: "location", sortable: true },
    {
      label: "Status",
      key: "status",
      render: (value) => (
        <span
          className={cn(
            "px-2 py-1 rounded",
            value === "Active"
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          )}
        >
          {value}
        </span>
      ),
    },
    { label: "Date", key: "date", sortable: true },
  ];

  return (
    <div>
      <FleetrifyCustomTable
        data={tableData}
        columns={columns}
        checkbox={true}
        renderLeftContent={renderLeftContent}
        actionMenu={actionMenu}
      />
    </div>
  );
};

export default CompanyBranchesTable;
